import { Link } from 'react-router-dom';
import { getTopRatedComics, type Comic } from '@/mocks/comics';

function RankingItem({ comic, rank }: { comic: Comic; rank: number }) {
  const rankColors = ['text-primary-500', 'text-accent-500', 'text-secondary-600'];
  const rankColor = rank <= 3 ? rankColors[rank - 1] : 'text-foreground-400';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="flex items-center gap-3 py-3 px-2 rounded-lg hover:bg-background-100 transition-colors group"
      data-product-shop
    >
      <span className={`w-7 text-center font-heading text-lg font-bold flex-shrink-0 ${rankColor}`}>
        {String(rank).padStart(2, '0')}
      </span>
      <div className="w-12 h-16 flex-shrink-0 overflow-hidden rounded bg-background-200">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 评分${comic.rating}分`}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h4>
        <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
      </div>
      <div className="flex items-center gap-0.5 flex-shrink-0">
        <div className="w-3 h-3 flex items-center justify-center">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
        </div>
        <span className="text-xs font-medium text-foreground-600">{comic.rating}</span>
      </div>
    </Link>
  );
}

export default function RankingSection() {
  const topComics = getTopRatedComics(10);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              排行榜
            </h2>
            <p className="text-sm text-foreground-500 mt-2">读者评分最高的漫画作品</p>
          </div>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 p-4">
          <div className="divide-y divide-background-200/50">
            {topComics.map((comic, index) => (
              <RankingItem key={comic.id} comic={comic} rank={index + 1} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}